// extracted by mini-css-extract-plugin
export default {"locked":"FeatureGate_locked__tUZu7","lockIcon":"FeatureGate_lockIcon__NyK87","title":"FeatureGate_title__DzaTO","upgradeBtn":"FeatureGate_upgradeBtn__8bLch"};